// extracted by mini-css-extract-plugin
module.exports = {"bb-hero-homepage-branded-tagline":"bb-hero-homepage-branded-tagline__RqAMA","heroOverlayAnimation":"heroOverlayAnimation__WGQSx"};